export default __webpack_public_path__ + "static/composer-demo-51e6fb58347efff7bac94356a831841c.mp4";